const enterTicketsCounterTemplate = require('./enterticketscounter.handlebars');

$(function () {
    if (!$('.enterticketscounter-container').length) return;

    let initialExtraChanceGameId = $('#initial-extra-chance-game-id').val();

    if (!initialExtraChanceGameId) return;

    //IF gameId is present on page, display current entry count automatically
    getEntriesCountForGame(initialExtraChanceGameId);

});

function getEntriesCountForGame(gameId) {
    switch (parseInt(gameId)) {
        case 1841:
            getExtremeMillionsEntryCount();
            break;
			case 1932:
            getUltimatevegasgetawayentriesEntryCount();
			break;
			case 156:
            getGasNGoEntryCount();
            break;
			case 149:
            getMegaGroceryEntryCount();
            break;
			case 2036:
            getCrossWordEntryCount();
            break;
			case 1952:
            getLuxuryCruisinEntryCount();
            break;
			case 152:
			getNYRockinEveEntryCount();
			break;
			case 153:
			getFanCaveEntryCount();
			break;
            default:
            updateCounterDisplay("-");
            break;
    }
};

function getExtremeMillionsEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
    let url='/api/v1/extrememillionsentriescount';
    $.ajax({
        url: url,
        type: 'GET',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}
function getUltimatevegasgetawayentriesEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
    let url='/api/v1/ultimatevegasgetawayentriescount';
    $.ajax({
        url: url,
        type: 'GET',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}
function getGasNGoEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
   let url='/api/v1/gasngoentriescount';
   $.ajax({
       url: url,
       type: 'GET',
      data: requestObject,
       dataType: 'json'
    })
       .done(function (data) {
           updateCounterDisplay(data);
       });
}
function getMegaGroceryEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
    let url='/api/v1/megagroceryentriescount';
    $.ajax({
        url: url,
        type: 'GET',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}
//function getCrossWordEntryCount() {
   // let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
   // let url='/api/v1/crosswordentriescount';
    //$.ajax({
      //  url: url,
      //  type: 'GET',
     //   data: requestObject,
     //   dataType: 'json'
   // })
     //  .done(function (data) {
       //     updateCounterDisplay(data);
       // });
//}
function getLuxuryCruisinEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
    let url='/api/v1/luxurycruisinentriescount';
    $.ajax({
        url: url,
        type: 'GET',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}
function getNYRockinEveEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
    let url='/api/v1/entriescount';
    $.ajax({
        url: url,
        type: 'GET',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}
function getFanCaveEntryCount() {
    let requestObject = { gameroomId: sessionStorage.getItem('GameroomID') };
    let url='/api/v1/fancaveentriescount';
    $.ajax({
        url: url,
        type: 'GET',
        data: requestObject,
        dataType: 'json'
    })
        .done(function (data) {
            updateCounterDisplay(data);
        });
}
function updateCounterDisplay(entryCount) {

    let $counterContainer = $('.enterticketscounter-entrycount-container');

    //fade out existing counteritems
    $counterContainer.find('.enterticketscounter-entrycount-counteritem span')
        //.removeClass('fade-in')
        .addClass('fade-out');

    //Delay updating dom until fade out is done
    setTimeout(function () {

        var entryCountSplit = entryCount.toString().split("");
        var entryCountArray;

        if (!entryCount || entryCount === 0) {
            entryCountArray = [0, 0];
        } else if (entryCount < 10) {
            entryCountSplit.unshift(0);
            entryCountArray = entryCountSplit;
        } else {
            entryCountArray = entryCountSplit;
        }

        let html = enterTicketsCounterTemplate({ data: { entryCountArray: entryCountArray } });
        $counterContainer.html(html);

        //Fade in new counteritems
        $counterContainer.find('.enterticketscounter-entrycount-counteritem span')
            .addClass('fade-in');

    }, 500);

}

module.exports = {
    getEntriesCountForGame: getEntriesCountForGame
}


// WEBPACK FOOTER //
// ./features/extrachances/enterticketscounter/enterticketscounter.js